import httpClient from '@/apis/base/httpclient';
import ProxyApi from './_proxyApi.js';

/**
 * API tích hợp với MISA Platform (MPL Core) — session check, tenant context, logout.
 * Controller BE không dùng convention [controller]s, mỗi action có route riêng
 * (mpl-session-status, mpl-tenant-context, mpl-logout) nên controllerName để rỗng
 * và tự nối path, tránh double-slash khi getAPIUrl() trả về có dấu / cuối.
 */
class MplPlatformAPI extends ProxyApi {
  constructor() {
    super();
  }
  controllerName = '';

  getBaseUrl() {
    return this.getAPIUrl().replace(/\/+$/, '');
  }

  /**
   * Kiểm tra cookie x-sessionid (phiên MPL) có tồn tại không.
   * FE gọi khi refresh token thất bại để quyết định re-trigger /mpl/accounting hay logoff hẳn.
   */
  checkMplSessionStatus() {
    let request = {
      url: [this.getBaseUrl(), 'mpl-session-status'].join('/'),
      isCheckExpiredToken: false,
    };

    return httpClient.getAsync(request);
  }

  /**
   * Lấy tenant context hiện tại từ cookie HttpOnly x-tenantid/x-subtenant-id (JS không đọc được trực tiếp).
   * Dùng để so sánh với context hiện tại và phát hiện đã chuyển đơn vị trên MPL Launcher.
   */
  getTenantContext() {
    let request = {
      url: [this.getBaseUrl(), 'mpl-tenant-context'].join('/'),
      isCheckExpiredToken: false,
    };

    return httpClient.getAsync(request);
  }

  /**
   * Đăng xuất khỏi phiên MPL — BE gọi MPL Core logout và trả về LoginUrl để FE redirect.
   */
  logout() {
    let request = {
      url: [this.getBaseUrl(), 'mpl-logout'].join('/'),
      isCheckExpiredToken: false,
    };

    return httpClient.getAsync(request);
  }
}

export default new MplPlatformAPI();
